import { PageTabs } from "./PageTabs";
import { useInCustomerProfile, usePartnerView } from "./partnerNav";
import styles from "./styles/PartnerNav.module.css";

/*
  A page title, with the partner tab strip underneath it.

  For anyone who is not a partner this renders the heading and nothing else --
  the same element, with the same class, in the same place -- so no existing
  page changes at all. That is the whole point of routing it through here rather
  than adding a conditional to five different components.

  `as` exists because the Dashboard's title is a div while every other page uses
  an h1, and changing that would alter their styling.
*/
export function PageHeading({ as: Tag = "h1", className, title, children }) {
  const partnerView = usePartnerView();
  const inCustomerProfile = useInCustomerProfile();
  const heading = <Tag className={className}>{title ?? children}</Tag>;

  /*
    Inside a customer's profile the page keeps no heading of its own -- the
    profile shows the customer's name and the tabs above it already.
  */
  if (inCustomerProfile) return null;

  if (!partnerView) return heading;

  /*
    The wrapper is `display: contents`, so it draws no box of its own and the
    heading keeps whatever the parent's layout was doing with it. Without that,
    a page whose container is a flex or grid would suddenly be laying out one
    wrapper instead of a heading, and the title would move.
  */
  return (
    <div className={styles.heading}>
      {heading}
      <PageTabs />
    </div>
  );
}
